import { ORDER_METHODS, RoomServiceLocationType } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'roomservice',
      [RoomServiceLocationType.TableService]: 'tafelservice',
    },
    [ORDER_METHODS.PICKUP]: 'afhalen',
    [ORDER_METHODS.DELIVERY]: 'bezorging',
  },
  errors: {
    draft_validation_failed: 'Vul je bezorgadres in voordat je doorgaat.',
  },
};
